import axiosInstance from "./axiosInstance";

export const getMembresias = async (id, page=1, limit=10) => {
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/obtenerMembresias?id=${id}&page=${page}&limit=${limit}`,
    { withCredentials: true }
  );
};
